import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const MAX_SELECTION_LINES = 6;

export function AIIslandEmptyState({
  selection,
  selectionLabel,
  tasksTitle,
  tasks = [],
  onTaskSelect,
}) {
  const { t } = useTranslation();
  const selectionPreview = useMemo(() => {
    if (!selection?.text) {
      return null;
    }
    const lines = String(selection.text).split(/\n/);
    const visibleLines = lines.slice(0, MAX_SELECTION_LINES);
    const previewText = visibleLines.join('\n');
    if (lines.length > MAX_SELECTION_LINES) {
      return `${previewText}\n…`;
    }
    return previewText;
  }, [selection]);

  return (
    <div className="ai-island-empty">
      {selectionPreview && (
        <div className="ai-island-empty__section">
          <div className="ai-island-empty__label">
            {selectionLabel || t('reports.aiIsland.empty.selectionLabel')}
          </div>
          <pre className="ai-island-empty__selection">{selectionPreview}</pre>
        </div>
      )}
      {tasks.length > 0 && (
        <div className="ai-island-empty__section">
          <div className="ai-island-empty__label">
            {tasksTitle || t('reports.aiIsland.empty.tasksTitle')}
          </div>
          <div className="ai-island-empty__tasks" role="list">
            {tasks.map((task, index) => {
              const label = typeof task === 'string' ? task : task?.label;
              if (!label) {
                return null;
              }
              const requiresSelection = Boolean(task?.requiresSelection);
              const isDisabled = requiresSelection && !selection?.text;
              return (
                <button
                  key={task?.id || `${label}-${index}`}
                  type="button"
                  className="ai-island-empty__task-button"
                  role="listitem"
                  disabled={isDisabled}
                  onClick={() => onTaskSelect?.(task)}
                >
                  {label}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
